import { render, staticRenderFns } from "./EventTicketGroupModalForm.vue?vue&type=template&id=06582af0&"
import script from "./EventTicketGroupModalForm.vue?vue&type=script&lang=js&"
export * from "./EventTicketGroupModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports